// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_BasicURL from "../Data.BasicURL/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Nullable from "../Data.Nullable/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Parsing from "../Parsing/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var show = /* #__PURE__ */ Data_Show.show(Parsing.showParseError);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var getEnv = function (obj) {
    return function (parse) {
        return function (key) {
            return bind(Data_Either.note("Missing env var: " + key)(Foreign_Object.lookup(key)(obj)))(function (nullableVal) {
                return bind(Data_Either.note("Env var is null: " + key)(Data_Nullable.toMaybe(nullableVal)))(function (val) {
                    return parse(val);
                });
            });
        };
    };
};
var parseStaticConfig = function (obj) {
    return bind(getEnv(obj)((function () {
        var $8 = lmap(show);
        return function ($9) {
            return $8(Data_BasicURL.parse($9));
        };
    })())("SPEED_MASTER_URL"))(function (speedMasterUrl) {
        return pure({
            speedMasterUrl: speedMasterUrl
        });
    });
};
var getStaticConfig = function __do() {
    var env = $foreign.getEnvRaw();
    return parseStaticConfig(env);
};
export {
    getStaticConfig
};
//# sourceMappingURL=index.js.map
